import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, Button, Typography, Tooltip } from "@mui/material";
import { useState } from "react";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import jsPDF from "jspdf";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import { esArray } from "src/general_components/functionEsArray";
import { actualizarContadorEstadisticas } from "src/general_helpers/EstadisticasData";

const MostrarImagenTabla = (data) => {
  const { setLoading, id_caja, id_contenido } = data;

  // Asegurar que data.row.link siempre sea un array
  const links = Array.isArray(data?.row?.link)
    ? data.row.link
    : data?.row?.link
      ? [data.row.link]
      : [];

  const cantidad_imagenes = data.row.cantidad_imagenes;

  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // Índice de la imagen actual
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  //Loading carga imagenes
  const [isPreloading, setIsPreloading] = useState(false);

  // Pre-cargar imágenes
  const preloadImages = (imageUrls) => {
    setIsPreloading(true);
    const promises = imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

    Promise.all(promises)
      .then(() => setIsPreloading(false))
      .catch(() => setIsPreloading(false));
  };

  const handleOpen = async () => {
    const estatCheck = await actualizarContadorEstadisticas("consultas");
    if (!estatCheck.permitido) {
      setSnackbarVisible(true);
      setMessage(estatCheck.message);
      setSeverity("error");
      return;
    }
    preloadImages(links); // Pre-cargar imágenes al abrir el modal
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentIndex(0); // Reiniciar el índice al cerrar
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % links.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? links.length - 1 : prevIndex - 1
    );
  };

const generarPdfContenidosImagenes = async () => {
  const estatCheck = await actualizarContadorEstadisticas("descargas");
  if (!estatCheck.permitido) {
    setSnackbarVisible(true);
    setMessage(estatCheck.message);
    setSeverity("error");
    return;
  }

  const imagenesUrl = esArray(data.row.link).map((imagen) => {
    return {
      src: imagen,
    };
  });

  const doc = new jsPDF();

  async function loadImage(image) {
    return new Promise((resolve, reject) => {
      let imageUrl = image.src;
      if (image.src.startsWith("http://www.digitaldlys")) {
        imageUrl = image.src.replace("http://", "https://");
      }
      fetch(imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Error al cargar la imagen: " + response.statusText);
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const imgElement = new Image();
          imgElement.src = url;
          imgElement.onload = () => {
            URL.revokeObjectURL(url);
            resolve(imgElement);
          };
          imgElement.onerror = reject;
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  try {
    setLoading(true);
    const loadedImages = await Promise.all(
      imagenesUrl.map((image) => loadImage(image))
    );

    if (loadedImages.some((image) => !image)) {
      throw new Error("Error al cargar una imagen.");
    }

    loadedImages.forEach((img, index) => {
      if (index !== 0) doc.addPage();

      const imgWidth = img.width;
      const imgHeight = img.height;

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Calcular la escala manteniendo la proporción
      const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);
      const newWidth = imgWidth * ratio;
      const newHeight = imgHeight * ratio;

      const marginX = (pageWidth - newWidth) / 2;
      const marginY = (pageHeight - newHeight) / 2;

      let imageUrl = imagenesUrl[index].src;
      if (imageUrl.startsWith("http://www.digitaldlys")) {
        imageUrl = imageUrl.replace("http://", "https://");
      }

      doc.addImage(imageUrl, "JPEG", marginX, marginY, newWidth, newHeight);
    });

    doc.save(`Digitalizaciones_${id_caja}_${id_contenido}.pdf`);
    setLoading(false);
    setSnackbarVisible(true);
    setMessage("Se generó correctamente el PDF.");
    setSeverity("success");
  } catch (error) {
    setLoading(false);
    setSnackbarVisible(true);
    setMessage("ERROR al generar el PDF.");
    setSeverity("error");
    console.error(error);
  }
};


  return (
    <div style={{ alignItems: "center", textAlign: "center", margin: "auto" }}>
      {/* Icono de Ojo y de Archivos */}
      {links.length > 0 && (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="body2" color="primary" gutterBottom>
            {`${cantidad_imagenes}`}
          </Typography>
          <Box display="flex" gap={1}>
            <Tooltip title="Ver" arrow>
              <IconButton onClick={handleOpen} color="primary">
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Generar PDF" arrow>
              <IconButton onClick={generarPdfContenidosImagenes} color="primary">
                <SimCardDownloadIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      )}


      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80vw",
            maxWidth: 600,
            height: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "hidden",
            "@media (max-width:600px)": {
              width: "95vw",
              height: "60vh",
              p: 1,
            },
          }}
        >
          {/* Encabezado */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6">Digitalizaciones</Typography>
            <IconButton onClick={handleClose} sx={{ color: "grey.700" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Contenedor de la Imagen */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              mb: 2,
            }}
          >
            {isPreloading ? (
              <Typography>Cargando imágenes...</Typography>
            ) : links.length > 0 ? (
              <img
                src={links[currentIndex]}
                alt={`Vista Previa ${currentIndex + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <Typography>No hay imágenes disponibles</Typography>
            )}
          </Box>

          {/* Botones de Navegación */}
          {links.length > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
              <Button onClick={handlePrev} variant="contained">
                Anterior
              </Button>
              <Button onClick={handleNext} variant="contained">
                Siguiente
              </Button>
            </Box>
          )}

          {/* Indicador de Posición */}
          <Typography variant="body2" sx={{ mt: 1 }}>
            {currentIndex + 1} / {links.length}
          </Typography>
        </Box>
      </Modal>

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => setSnackbarVisible(false)}
      />
    </div>
  );
};

export default MostrarImagenTabla;
